import React from 'react';
import { motion } from 'framer-motion';
import { useWeb3 } from '../../context/Web3Context';
const HL = [
  { i: '📈', t: '4% Monthly ROI', d: 'Daily passive income auto-calculated on blockchain' },
  { i: '⚡', t: 'Binary Income', d: '10% pair matching with unlimited depth' },
  { i: '📊', t: '10 Level Income', d: '5% from team ROI across 10 levels' },
  { i: '👑', t: 'Leadership Rewards', d: 'Up to 25% bonus on Level 1' },
  { i: '🔒', t: 'Future Staking Salary', d: 'Binary income grows at 2% monthly' },
  { i: '💎', t: 'Royalty Pool', d: 'Exclusive rewards for top leaders' }
];
const FT = [
  { i: '🔗', t: 'opBNB Chain', d: 'Ultra low gas' },
  { i: '🛡️', t: 'Smart Contract', d: 'Decentralized' },
  { i: '💰', t: 'USDT Based', d: 'Stable value' },
  { i: '🚀', t: 'Start $10', d: 'Low entry' }
];
const stagger = { hidden: {}, show: { transition: { staggerChildren: 0.08 } } };
const fadeUp = { hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.5 } } };

export default function LandingPage() {
  const { connectWallet, isConnecting } = useWeb3();
  return (<div className="land">
    <motion.div className="land-hero" initial="hidden" animate="show" variants={stagger}>
      <motion.img src="/logo.png" alt="Rich Factory" className="land-logo" variants={fadeUp} />
      <motion.h1 className="land-title" variants={fadeUp}>RICH FACTORY</motion.h1>
      <motion.p className="land-sub" variants={fadeUp}>CRYPTO PASSIVE INCOME</motion.p>
      <motion.button className="btn btn-primary" onClick={connectWallet} disabled={isConnecting} style={{ padding: '16px 48px', fontSize: '1rem' }} variants={fadeUp} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
        {isConnecting ? '⏳ Connecting...' : '🔗 Connect Wallet'}
      </motion.button>
      <motion.div className="land-badge" variants={fadeUp}><span className="land-dot" />Secured on opBNB Chain</motion.div>
    </motion.div>
    <div className="land-sec">
      <h2 className="land-sec-title">About</h2>
      <motion.div className="card" style={{ textAlign: 'center' }} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p style={{ color: 'var(--text2)', fontSize: '0.85rem', lineHeight: 1.8 }}>Rich Factory is a next-generation decentralized passive income platform on opBNB blockchain. Smart contract powered binary system ensures transparent, automated income.</p>
      </motion.div>
    </div>
    <div className="land-sec">
      <h2 className="land-sec-title">6 Income Streams</h2>
      <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={stagger}>
        {HL.map((h, i) => (
          <motion.div key={i} className="card hl-card" variants={fadeUp}>
            <div className="hl-icon">{h.i}</div><div><div className="hl-title">{h.t}</div><div className="hl-desc">{h.d}</div></div>
          </motion.div>
        ))}
      </motion.div>
    </div>
    <div className="land-sec">
      <h2 className="land-sec-title">Why Rich Factory</h2>
      <div className="g2">{FT.map((f, i) => (
        <motion.div key={i} className="card fcc" style={{ padding: '20px 12px' }} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
          <div style={{ fontSize: '1.5rem', marginBottom: 8 }}>{f.i}</div>
          <div style={{ fontSize: '0.82rem', color: '#fff', fontWeight: 700, marginBottom: 3 }}>{f.t}</div>
          <div style={{ fontSize: '0.68rem', color: 'var(--text3)' }}>{f.d}</div>
        </motion.div>
      ))}</div>
    </div>
    <div style={{ textAlign: 'center', padding: '30px 20px 50px' }}>
      <motion.button className="btn btn-gold" onClick={connectWallet} disabled={isConnecting} style={{ padding: '16px 48px' }} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>🚀 Start Earning Now</motion.button>
      <p style={{ color: 'var(--text3)', fontSize: '0.65rem', marginTop: 20 }}>© 2025 Rich Factory</p>
    </div>
  </div>);
}
